// extracted by mini-css-extract-plugin
export var circle = "LabelledImage-module--circle--ae8e8";
export var container = "LabelledImage-module--container--cd8c3";
export var feature = "LabelledImage-module--feature--d6310";
export var image = "LabelledImage-module--image--f7965";
export var imageWrapper = "LabelledImage-module--imageWrapper--8a594";
export var innerCircle = "LabelledImage-module--innerCircle--7fe74";
export var svg = "LabelledImage-module--svg--b0504";